import React from 'react';
import { ReportType } from './ReportTypeSelector';

const RoleFilter = {
  ALL: 'ALL',
  INSPECTOR: 'INSPECTOR',
  PROPERTY_MANAGER: 'PROPERTY_MANAGER'
};

const RoleFilterSelector = ({ value, onChange, reportType }) => {
  if (reportType !== ReportType.INSPECTOR_PROPERTY_MANAGER) {
    return null;
  }

  const roleOptions = [
    { value: RoleFilter.ALL, label: 'Inspector & Property Manager (Combined)' },
    { value: RoleFilter.INSPECTOR, label: 'Inspector Only' },
    { value: RoleFilter.PROPERTY_MANAGER, label: 'Property Manager Only' }
  ];

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Role Filter
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-500 focus:ring-sky-500"
      >
        {roleOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <p className="text-sm text-gray-500">
        Select which roles to include in the report
      </p>
    </div>
  );
};

export { RoleFilter };
export default RoleFilterSelector; 